import { render } from "./teacherInfo.vue?vue&type=template&id=62a84700&scoped=true"
import script from "./teacherInfo.vue?vue&type=script&lang=js"
export * from "./teacherInfo.vue?vue&type=script&lang=js"

import "./teacherInfo.vue?vue&type=style&index=0&id=62a84700&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a84700"]])

export default __exports__